import { createApp } from 'vue';

import BannerBlock from '../BannerBlock/BannerBlock.vue';

function mountBannerBlocks() {
	const blocks = document.querySelectorAll('[data-feature="banner-block"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'BannerBlockApp',
		});

		app.component('banner-block', BannerBlock);
		app.mount(block);
	})
}

mountBannerBlocks();